export const BugsnagApiID = import.meta.env.BIFROST_BUGSNAG_APP_ID;

export const BugsnagApiKey = import.meta.env.BIFROST_BUGSNAG_API_KEY;
